import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NotationsService } from '../../../@core/utils';
import { I18nService } from '../../../@core/utils/i18n.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-displayed-investment-price',
    styleUrls: ['./displayed-investment-price.component.scss'],
    templateUrl: './displayed-investment-price.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class DisplayedInvestmentPriceComponent implements OnInit, OnChanges {

  @Input() public price: number;
  @Input() public nbInvestments: number;
  @Input() public replacementYear: number;
  @Input() public linkParams: any;
  @Input() public lastRoute: any;
  @Input() public hypothesis: boolean = false;
  @Input() public disabled: boolean = false;
  @Output() public updateLastRoute = new EventEmitter<void>();

  public formattedPrice: string;
  public currencySlug: string;

  constructor(
    private i18nService: I18nService,
    private router: Router,
    private notationsService: NotationsService,
  ) { }

  public ngOnInit() {
    this.formatPrice(this.price);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.price) {
      this.formatPrice(this.price);
    }
  }

  private formatPrice(price: number) {
    if (!Number.isNaN(Number(price)) && this.nbInvestments > 0) {
      [this.formattedPrice, this.currencySlug] = this.i18nService.formatCurrency(price, 1).split(' ');
    } else {
      this.formattedPrice = '-';
      this.currencySlug = '';
    }
  }

  openSpreadsheet(event) {
    event.stopImmediatePropagation();
    if (this.lastRoute) {
      this.notationsService.lastRouteInfo = this.lastRoute;
    } else {
      this.notationsService.lastRouteInfo = {
        superCategory: null,
        showCategories: null,
        category: null,
        subCategory: null,
        assetType: null,
        asset: null,
        site: null,
        perimeter: null,
        showSuperCategories: false,
      };
    }
    this.updateLastRoute.emit();
    if (this.router.url === '/insight/notations') {
      this.linkParams['fromNotationFamily'] = 'true';
    } else {
      this.linkParams['fromNotation'] = 'true';
    }

    this.router.navigate(['/single-pages/investments'], { queryParams: this.linkParams });

  }
}
